/* eslint-disable jsx-a11y/anchor-is-valid */
import LocalizeSelector from 'components/LocalizeSelector'
import { useTranslation } from 'contexts/Localization'
import Image from 'next/image'
import { Link } from 'widgets'

const Footer = () => {
  const { t } = useTranslation()

  return (
    <footer className="lg:py-12 py-6 surface_background_0 border-t border-solid stroke-sm">
      <div className="flex flex-col lg:flex-row gap-5 items-center justify-between container mx-auto">
        <Link
          href="https://nft.monbase.com/"
          onClick={(e) => {
            e.preventDefault()
            window.location.href = 'https://nft.monbase.com/'
          }}
        >
          <Image width={40} height={40} src="/bcc/images/logo.svg" alt="logo" />
        </Link>
        <div className="hidden lg:flex items-center gap-5">
          <p>Copyright 2024 Monbase. All rights reserved</p>
          <p>We use cookies for better services</p>
        </div>
        <LocalizeSelector />

        <div className="flex flex-col md:flex-row md:self-center md:gap-5 gap-1 lg:hidden text-base self-start">
          <p>Copyright 2024 Monbase. All rights reserved</p>
          <p>We use cookies for better services</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
